import { useEffect, useState } from 'react'

import { useController } from '../../hooks/useController'

interface Confirmations {
  deleteOrders: boolean
  revokeRoutes: boolean
  undoWarning: boolean
}

export function useDeleteOrders() {
  const [confirmations, setConfirmations] = useState<Confirmations>({
    deleteOrders: false,
    revokeRoutes: false,
    undoWarning: false,
  })

  const { updateData } = useController()

  useEffect(() => {
    const allConfirmed =
      confirmations.deleteOrders && confirmations.revokeRoutes && confirmations.undoWarning

    updateData({
      canDeleteOrders: allConfirmed,
    })
  }, [confirmations, updateData])

  const handleCheckboxChange = (key: keyof Confirmations) => (checked: boolean) => {
    setConfirmations(prev => ({
      ...prev,
      [key]: checked,
    }))
  }

  return {
    confirmations,
    handleCheckboxChange,
  }
}
